var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2301_1189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2301_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 26.6666C6.64412 26.6666 4.91634 25.9666 3.48301 24.5666C2.04967 23.1666 1.33301 21.4555 1.33301 19.4333C1.33301 17.6999 1.85523 16.1555 2.89967 14.7999C3.94412 13.4444 5.31079 12.5777 6.99967 12.1999C7.55523 10.1555 8.66634 8.49992 10.333 7.23325C11.9997 5.96659 13.8886 5.33325 15.9997 5.33325C18.5997 5.33325 20.8052 6.23881 22.6163 8.04992C24.4275 9.86103 25.333 12.0666 25.333 14.6666C26.8663 14.8444 28.1386 15.5055 29.1497 16.6499C30.1608 17.7944 30.6663 19.1333 30.6663 20.6666C30.6663 22.3333 30.083 23.7499 28.9163 24.9166C27.7497 26.0833 26.333 26.6666 24.6663 26.6666H17.333C16.5997 26.6666 15.9719 26.4055 15.4497 25.8833C14.9275 25.361 14.6663 24.7333 14.6663 23.9999V17.1333L12.533 19.1999L10.6663 17.3333L15.9997 11.9999L21.333 17.3333L19.4663 19.1999L17.333 17.1333V23.9999H24.6663C25.5997 23.9999 26.3886 23.6777 27.033 23.0333C27.6775 22.3888 27.9997 21.5999 27.9997 20.6666C27.9997 19.7333 27.6775 18.9444 27.033 18.2999C26.3886 17.6555 25.5997 17.3333 24.6663 17.3333H22.6663V14.6666C22.6663 12.8221 22.0163 11.2499 20.7163 9.94992C19.4163 8.64992 17.8441 7.99992 15.9997 7.99992C14.1552 7.99992 12.583 8.64992 11.283 9.94992C9.98301 11.2499 9.33301 12.8221 9.33301 14.6666H8.66634C7.37745 14.6666 6.27745 15.1221 5.36634 16.0333C4.45523 16.9444 3.99967 18.0444 3.99967 19.3333C3.99967 20.6221 4.45523 21.7221 5.36634 22.6333C6.27745 23.5444 7.37745 23.9999 8.66634 23.9999H11.9997V26.6666H8.66634Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d08bd6eba987cde30a9e59d19b7dcac7.svg";
export { ForwardRef as ReactComponent };